import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { TimeSaleTemplate } from 'components/Templates'

const TimeSale: FC = () => {
  return (
    <Layout iconPath={'/icon/white/clock.svg'} headline={'タイムセール'} title={'タイムセール'}>
      <TimeSaleTemplate />
    </Layout>
  )
}

export default TimeSale
